module.exports = __webpack_public_path__ + "static/media/babel-1-right.37e93f69.webp";